import React from 'react';
import './BusinessDomains.css';

const BusinessDomains = ({ title = null, subtitle = null, domains = null }) => {
  // コンポーネント側で全てのデータを定義
  const defaultTitle = '私たちの事業分野';
  const defaultSubtitle = '多様な業界・企業との関わりを通じて、エンジニア一人ひとりが幅広い経験を積める環境があります。';
  
  const defaultDomains = [
    {
      title: '現場実装・人材支援（開発／SES）',
      services: [
        {
          title: 'システム開発',
          description: '要件定義からシステム設計、実装、テストまで一貫して対応。AIやIoT、クラウド、DevOpsなど最新技術を活用したシステム開発にも対応します。'
        },
        {
          title: 'インフラ構築',
          description: 'ネットワーク、サーバ、データベース、クラウド環境など、ビジネスのニーズに応じたインフラ構築業務をサポート。企業のIT基盤を強化します。'
        }
      ]
    },
    {
      title: 'AI活用・AI導入支援（研修 → 導入 → 実装）',
      services: [
        {
          title: 'AI研修',
          description: '基本的なAI概念から高度な実装戦略まで、カスタマイズされた教育プログラム。参加者がAI技術を実世界のビジネス課題解決に適用できるようサポートします。'
        },
        {
          title: 'AI構築・AI開発',
          description: '初期コンセプト開発とデータ準備からモデルトレーニング、デプロイ、継続的なメンテナンスまで、カスタムAIシステム構築のエンドツーエンドソリューションを提供します。'
        },
        {
          title: 'AI画像・動画生成',
          description: '最先端の生成AI技術を活用し、カスタム画像、動画、マルチメディアコンテンツを作成。マーケティング素材の強化と魅力的なコンテンツ作成を支援します。'
        }
      ]
    },
    {
      title: 'DX事業',
      services: [        
        {
          title: 'DX推進',
          description: 'AI、IoT、クラウド、ビッグデータなどの最新技術を活用し、企業のデジタル化を加速。業務効率向上とビジネスモデル革新を支援します。'
        }
      ]
    }
  ];

  const displayTitle = title !== null ? title : defaultTitle;
  const displaySubtitle = subtitle !== null ? subtitle : defaultSubtitle;
  const displayDomains = domains !== null ? domains : defaultDomains;

  return (
    <section className="business-domains-section">
      <div className="dynamic-container">
        {displayTitle && <h2 className="business-domains-title">{displayTitle}</h2>}
        {displaySubtitle && <p className="business-domains-subtitle">{displaySubtitle}</p>}
        <div className="business-domains-grid">
          {displayDomains.map((domain, domainIndex) => (
            <div key={domainIndex} className="business-domain-card">
              <h3 className="business-domain-title">{domain.title}</h3>
              <div className="business-domain-services">
                {domain.services.map((service, serviceIndex) => (
                  <div key={serviceIndex} className="business-service">
                    <h4 className="business-service-title">{service.title}</h4>
                    <p className="business-service-description">{service.description}</p>
                    {service.link && (
                      <a href={service.link} className="business-service-link">
                        詳しく見る →
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessDomains;
